import { render, staticRenderFns } from "./MultiPaired.vue?vue&type=template&id=29f76fa4&"
import script from "./MultiPaired.vue?vue&type=script&lang=js&"
export * from "./MultiPaired.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports